import type { ContentNavigationIcon } from '@/data/contentNavigation';
import {
  BookMarked, BookOpen, BriefcaseBusiness, Compass, FileText, Gift,
  GraduationCap, LayoutGrid, Lightbulb, ListChecks, Megaphone, PenTool,
  Store, Users, Wrench,
} from 'lucide-react';
import type { ComponentType } from 'react';

export const contentNavigationIconMap = {
  blog: FileText,
  directory: LayoutGrid,
  'free-tools': Gift,
  book: BookOpen,
  ebook: BookMarked,
  'lead-magnet': Megaphone,
  kdp: Store,
  coach: Users,
  consultant: BriefcaseBusiness,
  course: GraduationCap,
  agency: Wrench,
  author: PenTool,
  ideas: Lightbulb,
  marketplace: Compass,
  'course-free': ListChecks,
} satisfies Record<ContentNavigationIcon, ComponentType<{ className?: string }>>;
